import { INSTAGRAM, IMG } from "../../data/site";
import { Instagram, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-black border-t border-white/10 pt-16 pb-10 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <div className="flex items-baseline gap-2">
            <span className="font-heading text-xl font-bold uppercase text-white">Sasya</span>
            <span className="font-heading text-xl font-bold uppercase text-red-600">Hero</span>
          </div>
          <p className="mt-3 text-zinc-400 text-sm max-w-sm">
            Authorised Hero MotoCorp & VIDA dealer, serving Kurnool & Kodumur since 2002.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <div className="bg-white rounded px-3 py-2"><img src={IMG.heroLogo} alt="Hero MotoCorp" className="h-7 w-auto object-contain" /></div>
            <div className="bg-white rounded px-3 py-2"><img src={IMG.vidaLogo} alt="VIDA" className="h-7 w-auto object-contain" /></div>
          </div>
        </div>
        <div className="flex items-center gap-5">
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-red-500 transition-colors" data-testid="footer-instagram"><Instagram /></a>
          <a href="tel:9281452805" className="text-zinc-400 hover:text-red-500 transition-colors" data-testid="footer-call"><Phone /></a>
        </div>
      </div>

      <div className="mt-12 select-none">
        <div className="font-heading font-bold uppercase tracking-tighter leading-none text-white/[0.06] text-[18vw] md:text-[15vw] whitespace-nowrap">
          SASYA HERO
        </div>
      </div>

      <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-zinc-500 uppercase tracking-widest">
        <span>© {new Date().getFullYear()} Sasya Hero. All rights reserved.</span>
        <div className="flex items-center gap-4">
          <Link to="/admin" className="hover:text-red-500 transition-colors" data-testid="footer-dashboard-link">Team Dashboard</Link>
          <span>Kurnool • Kodumur • Andhra Pradesh</span>
        </div>
      </div>
    </div>
  </footer>
);
